import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import SimpleTable from 'components/complex/simpleTable/SimpleTable';
import WadiumField from './WadiumField';
import Tr from 'translations/Translations';
import { withRouter } from "react-router";
import { connect } from 'react-redux'
import Loading from 'components/Loading';

const style = theme => ({
	root: {

	},
	lpColumn: theme.components.table.lpColumn,
	wadiumColumn: {
		width: 300,
	},
	text: {
		...theme.typography.cutLines(1),
	}
})

function WadiumTable({
	classes,
	formikProps,
	guaranteeList
}) {

	const createItems = (item, i) => {
		return [
			i+1,
			item.name,
			<WadiumField index={i} value={item.value} formikProps={formikProps} />
		]
	}

	const createTab = () => {
		const tab = []
		guaranteeList.dealings.forEach((x, i) => tab.push(createItems(x, i)));
		return tab
	}


	if (!guaranteeList) return <Loading />
	return (
		<div className={classes.root}>
			<SimpleTable
				columnClasses={[
					classes.lpColumn,
					undefined,
					classes.wadiumColumn,
				]}
				headers={[
					Tr('column_lp'),
					Tr('ordered_object'),
					Tr('wadium')
				]}
				items={createTab()}
			/>
		</div>
	)
}

WadiumTable.propTypes = {
	classes: PropTypes.any,
}

export default connect((state) => ({
	guaranteeList: state.resources.guaranteeList
}), {
})(withRouter(withStyles(style)(WadiumTable)));
